import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

const stepperData = [
  "内容入力",
  "対象施設一覧確認・異動状況登録",
  "入力内容確認",
  "機構へ提出",
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    type: "explanatoryText",
    keyword: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC050009_01,
    explanatoryTextRule: "\\n",
  },
  {
    title: "契約者（法人）名",
    keyword: "contractorName",
    type: "text",
    showLine: false,
  },
  {
    title: "経営者でなくなった年月日",
    keyword: "managerDateOfDisappearance",
    type: "text",
  },
  {
    title: "経営者でなくなった理由",
    keyword: "managerReasonOfDisappearance",
    type: "nodeInLine",
  },
  {
    title: "理由",
    keyword: "reason",
    type: "text",
  },
  {
    title: "廃止・休止が確認できる書類",
    keyword: "downloadLink",
    type: "downloadLink",
    downloadBase64: true,
  },
  {
    title:
      "社会福祉施設等、特定介護保険施設等又は申出施設等の名称、被共済職員数",
    keyword: "facilityName",
    type: "nodeInLine",
  },
  {
    title: "変更後の共済契約者番号",
    keyword: "numberAfterChange",
    type: "text",
  },
  {
    title: "変更後の共済契約者名",
    keyword: "nameAfterChange",
    type: "text",
  },
];

const schema = {};

export { stepperData, schema, fakeTableList };
